import { Dialog, Flex, Stack, Text } from '@chakra-ui/react';
import { Switch } from '@halo/ui-react';
import { Avatar, ButtonRed, GroupIcon } from '@halo/ui-chat-react';

export function ExitGroupDialog({
  isOpen,
  setIsOpen,
  avatar,
  name,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  avatar: string;
  name: string;
}) {
  const { t } = useTranslation();
  return (
    <Dialog.Root
      placement="center"
      open={isOpen}
      onOpenChange={(details) => setIsOpen(details.open)}
      unmountOnExit
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content bg="bg.subtle" rounded="2xl" width="388px">
          <Dialog.Header px="5" pt="4">
            <Dialog.Title fontWeight="semibold" fontSize="md">
              {t('chat.exitGroupTitle')}
            </Dialog.Title>
          </Dialog.Header>
          <Dialog.Body px="5" pt="0" py="5">
            <Stack direction="column" alignItems="center" justifyContent="center">
              <Avatar src={avatar} size="2xl" />
              <Flex align="center" gap="1" fontSize="md" fontWeight="semibold">
                <GroupIcon />
                <Text flex="1" fontWeight="semibold" truncate>
                  {name}
                </Text>
              </Flex>
              <Flex
                align="center"
                justify="space-between"
                bg="bg"
                w="full"
                rounded="lg"
                py="3"
                px="3"
                mt="2.5"
              >
                <Stack gap="1" lineHeight="normal">
                  <Text fontSize="sm" fontWeight="semibold" truncate>
                    {t('chat.reportGroup')}
                  </Text>
                  <Text fontSize="xs" fontWeight="semibold" color="fg.muted" truncate>
                    {t('chat.reportGroupDesc')}
                  </Text>
                </Stack>
                <Switch />
              </Flex>
            </Stack>
          </Dialog.Body>
          <Dialog.Footer px="5">
            <ButtonRed flex="1" variant="outline" onClick={() => {}}>
              {t('buttons.exitGroup')}
            </ButtonRed>
            <ButtonRed flex="1" onClick={() => {}}>
              {t('buttons.exitAndDelete')}
            </ButtonRed>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
